import { selectSingle, isEmptyValue, clearElement, joinValues } from './LegacyModeStrategy.js';

class FreetextModeStrategy {
    constructor(context) {
        this.context = context;
        this.mode = "freetext";
    }
    onChange() {
        if (this.context.element.value === this.context.element.getAttribute("data-value"))
            return;
        this.context.element.setAttribute("data-value", this.context.element.value);
        this.context.emitComboChange();
    }
    onSelect(item, index) {
        selectSingle(this.context, item, index);
    }
    getValue() {
        const dataValue = this.context.element.getAttribute("data-value")?.trim() ?? "";
        if (dataValue)
            return dataValue;
        const text = this.context.element.value.trim();
        return text || null;
    }
    setValue(value) {
        if (isEmptyValue(value)) {
            clearElement(this.context.element);
            return true;
        }
        const display = Array.isArray(value)
            ? joinValues(value, this.context.element, this.context.semicolon)
            : String(value).trim();
        this.context.element.value = display;
        this.context.element.setAttribute("data-value", display);
        this.context.element.setAttribute("data-title", display);
        return true;
    }
    hasValue() {
        return this.context.element.value.trim() !== "";
    }
    getValueTitle() {
        const value = this.context.element.value.trim();
        return value || null;
    }
}

export { FreetextModeStrategy };
